import { useState } from "react";

export interface CreateContractStepOneData {
  name: string;
  totalValue: string;
  numberOfInstallments: string;
  startDate: string;
  userIds: string[];
}

export interface CreateContractValidationErrors {
  name?: string;
  totalValue?: string;
  numberOfInstallments?: string;
  startDate?: string;
  general?: string;
}

export function useCreateContractValidation() {
  const [errors, setErrors] = useState<CreateContractValidationErrors>({});

  const validateStepOne = (data: CreateContractStepOneData): boolean => {
    const newErrors: CreateContractValidationErrors = {};

    if (!data.name.trim()) {
      newErrors.name = "Nome do contrato é obrigatório";
    }

    const total = parseFloat(data.totalValue);
    if (!data.totalValue || Number.isNaN(total) || total <= 0) {
      newErrors.totalValue = "Valor total deve ser maior que zero";
    }

    const count = parseInt(data.numberOfInstallments, 10);
    if (!data.numberOfInstallments || Number.isNaN(count) || count < 1) {
      newErrors.numberOfInstallments = "Número de parcelas deve ser pelo menos 1";
    }

    if (!data.startDate) {
      newErrors.startDate = "Data da primeira parcela é obrigatória";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearErrors = () => setErrors({});

  return { errors, validateStepOne, clearErrors, setErrors };
}
